import React from 'react';
type Props = {
  children: React.ReactNode;
  className?: string;
  tone?: 'dark' | 'light';
};
export function PhoneFrame({
  children,
  className = '',
  tone = 'dark'
}: Props) {
  const screenBg = tone === 'dark' ? 'bg-solventum-dark' : 'bg-white';
  return <div className={`relative mx-auto w-[300px] sm:w-[320px] max-w-full ${className}`} data-id="element-312">
      {/* Outer chassis */}
      <div className="relative aspect-[9/19.5] bg-black rounded-[44px] p-[8px] shadow-[0_30px_80px_-20px_rgba(0,0,0,0.6)] ring-1 ring-white/5" data-id="element-313">
        {/* Inner screen */}
        <div className={`relative w-full h-full rounded-[37px] overflow-hidden ${screenBg}`} data-id="element-314">
          {/* Dynamic island */}
          <div className="absolute top-2 left-1/2 -translate-x-1/2 w-[92px] h-[26px] bg-black rounded-full z-40" data-id="element-315" />
          {/* Status bar */}
          <div className={`absolute top-0 left-0 right-0 h-10 px-6 flex items-center justify-between text-[11px] font-semibold z-30 ${tone === 'dark' ? 'text-white' : 'text-solventum-dark'}`} data-id="element-316">
            <span data-id="element-317">9:41</span>
            <div className="flex items-center gap-1" data-id="element-318">
              {/* Signal dots */}
              <div className="flex items-end gap-[2px] h-3" data-id="element-319">
                <div className={`w-[3px] h-[4px] rounded-sm ${tone === 'dark' ? 'bg-white' : 'bg-solventum-dark'}`} data-id="element-320" />
                <div className={`w-[3px] h-[6px] rounded-sm ${tone === 'dark' ? 'bg-white' : 'bg-solventum-dark'}`} data-id="element-321" />
                <div className={`w-[3px] h-[8px] rounded-sm ${tone === 'dark' ? 'bg-white' : 'bg-solventum-dark'}`} data-id="element-322" />
                <div className={`w-[3px] h-[10px] rounded-sm ${tone === 'dark' ? 'bg-white' : 'bg-solventum-dark'}`} data-id="element-323" />
              </div>
              {/* Battery */}
              <div className={`ml-1 w-6 h-3 rounded-[3px] border ${tone === 'dark' ? 'border-white/70' : 'border-solventum-dark/70'} relative`} data-id="element-324">
                <div className={`absolute inset-[1px] right-[5px] rounded-[1.5px] ${tone === 'dark' ? 'bg-white' : 'bg-solventum-dark'}`} data-id="element-325" />
              </div>
            </div>
          </div>
          {/* App content */}
          <div className="absolute inset-0 pt-10" data-id="element-326">{children}</div>
          {/* Home indicator */}
          <div className={`absolute bottom-1.5 left-1/2 -translate-x-1/2 w-28 h-[5px] rounded-full z-30 ${tone === 'dark' ? 'bg-white/60' : 'bg-solventum-dark/40'}`} data-id="element-327" />
        </div>
      </div>
    </div>;
}